import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import z from "zod";
import { recordInstanceQueryOptions } from "@/services/record";

/**
 * Thin Record entity layout — shared params / soft prefetch for drawer tabs and workspace.
 * Drawer chrome lives in the pathless `_drawer` layout; workspace is a sibling route.
 */
export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/records/(record)/$recordId",
)({
	params: {
		parse: (params) => ({
			recordId: z.string().parse(params.recordId),
		}),
	},
	beforeLoad: ({ location, params }) => {
		const normalized = location.pathname.replace(/\/$/, "");
		const exactRoot = normalized.endsWith(`/records/${params.recordId}`);
		if (exactRoot) {
			throw redirect({
				to: "/web/$orgId/records/$recordId/details",
				params: {
					orgId: params.orgId,
					recordId: params.recordId,
				},
				search: {},
			});
		}
	},
	loader: ({ context, params }) => {
		// Prefetch without blocking — drawer opens immediately with loading state.
		void context.queryClient.prefetchQuery(
			recordInstanceQueryOptions.detail(params.recordId, {
				organizationId: params.orgId,
			}),
		);
	},
	component: RecordIdLayout,
});

function RecordIdLayout() {
	return <Outlet />;
}
